import api from './axios';

export const systemSettingsApi = {
  // Get all system settings or specific keys
  getAll(keys = null) {
    const params = {};
    if (Array.isArray(keys) && keys.length > 0) {
      params.keys = keys;
    }
    return api.get('/system-settings', { params });
  },

  // Update system settings (upsert)
  update(payload) {
    return api.put('/system-settings', payload);
  },

  getLlmModels() {
    return api.get('/system-settings/llm-models');
  },

  getLlmModelCatalog(query = '', limit = 100) {
    const params = { limit };
    if (query && query.trim()) {
      params.q = query.trim();
    }
    return api.get('/system-settings/llm-model-catalog', { params });
  },

  pullLlmModel(name) {
    return api.post('/system-settings/llm-models/pull', { name });
  },

  getPullJobStatus(jobId) {
    return api.get(`/system-settings/llm-models/pull/${jobId}`);
  },

  deletePullJob(jobId) {
    return api.delete(`/system-settings/llm-models/pull/${jobId}`);
  },

  updateLlmModel(value) {
    return this.update({ live_sessions_llm_model: value });
  },

  // Helper methods for specific settings
  getPromptTemplate() {
    return this.getAll(['live_sessions_prompt_template']).then(response => ({
      data: { value: response.data.live_sessions_prompt_template || '' }
    }));
  },

  updatePromptTemplate(value) {
    return this.update({ live_sessions_prompt_template: value });
  },

  createPromptTemplate(value) {
    return this.update({ live_sessions_prompt_template: value });
  }
};
